import axios from 'axios'
import { getImmediateLoadingAdminToken, clearImmediateLoadingAdminSession } from './immediateLoadingAdminSession'

const client = axios.create({
  baseURL: '/platform_api/v1/immediate-loading/admin/fullarch',
  timeout: 30000
})
client.interceptors.request.use(config => {
  const token = getImmediateLoadingAdminToken()
  if (token) config.headers.Authorization = 'Bearer ' + token
  return config
})
client.interceptors.response.use(response => {
  if (response.data && response.data.code === 200) return response.data.result
  const error = new Error((response.data && (response.data.message || response.data.result)) || '服务响应格式错误')
  error.status = response.status
  throw error
}, failure => {
  const response = failure.response
  const body = response && response.data
  const error = new Error((body && (body.message || body.msg)) || '网络连接失败，请重试')
  error.status = response && response.status
  error.code = body && body.code
  // 403 是权限不足；503/网络错误也不代表会话失效。
  if (error.status === 401) {
    clearImmediateLoadingAdminSession()
    window.dispatchEvent(new CustomEvent('immediate-loading-admin-auth-expired'))
  }
  return Promise.reject(error)
})

export const listFullArchRecords = (kind, params) => client.get('/' + kind, { params })
export const getFullArchDetails = (kind, id, params) => client.get(
  kind === 'audit' ? '/orders/' + encodeURIComponent(id) + '/audit' : '/users/' + encodeURIComponent(id) + '/ledger', { params }
)
export const reconcileFullArchOrder = (orderNo, reason) => client.post('/orders/' + encodeURIComponent(orderNo) + '/reconcile', { reason })



// WEBPACK FOOTER //
// ./src/assets/utils/fullArchAdminApi.js